import React from "react";

const offers = [
  {
    id: 1,
    title: "Book Your Ride with Rising Cab Service",
    description:
      "Travel with confidence using our reliable cab services for airport transfers, local travel, corporate transportation and outstation trips.",
    image: "/images/ctainnova.png",
    btnClass: "th-btn sm style2 bg-theme-3 text-title",
    buttonText: "Book Now",
    link: "/booking",
  },
  {
    id: 2,
    title: "Contact Our Travel Experts",
    description:
      "Speak with our team for assistance with airport transfers, local travel, corporate transportation and outstation trip planning.",
    image: "/images/ctaertiga.png",
    btnClass: "th-btn sm style2",
    buttonText: "Contact Us",
    link: "/contact-us",
  },
];

const ServiceOffer = () => {
  return (
    <section className="service-offer-sec-1 py-4">
      <div className="container">
        <div className="row gy-4">
          {offers.map((offer) => (
            <div className="col-lg-6" key={offer.id}>
              <div
                className="service-offer-wrapper mega-hover"
                style={{
                  backgroundImage: `url(${offer.image})`,
                  backgroundSize: "cover",
                  backgroundPosition: "center",
                  backgroundRepeat: "no-repeat",
                }}
              >
                <div className="service-offer-box">
                  <h3 className="box-title">
                    {offer.title}
                  </h3>

                  <p className="box-text">
                    {offer.description}
                  </p>

                  <a
                    href={offer.link}
                    className={offer.btnClass}
                  >
                    {offer.buttonText}
                    <i className="fas fa-arrow-up-right ms-2"></i>
                  </a>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServiceOffer;